import api from '../services/api';

// Ouvre le PDF récap d'un dossier Tour du véhicule dans un nouvel onglet.
// Onglet ouvert pendant le clic : le serveur peut mettre quelques secondes à
// regénérer un ancien PDF, et un window.open tardif serait bloqué.
// Lève une erreur si le PDF est indisponible (l'onglet est alors refermé).
export async function ouvrirPdfTourVehicule(dossierId) {
  const onglet = window.open('', '_blank');
  if (onglet) {
    onglet.opener = null;
    onglet.document.title = 'PDF récap…';
    onglet.document.body.innerHTML = '<p style="font-family:sans-serif;padding:24px">Préparation du PDF…</p>';
  }
  try {
    const { data } = await api.get(`/tour-vehicule/${dossierId}/pdf`);
    if (!data.url) throw new Error('URL manquante');
    if (onglet) onglet.location.href = data.url;
    else window.open(data.url, '_blank', 'noopener,noreferrer');
  } catch (err) {
    if (onglet) onglet.close();
    throw err;
  }
}
